import React from 'react';

import { SVGProps } from './SVGProps';

const DashboardRefreshIcon = ({ fill = '#101828', width = '24', height = '25' }: SVGProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 10.1367C21 10.1367 18.995 7.40494 17.3662 5.77496C15.7373 4.14499 13.4864 3.13672 11 3.13672C6.02944 3.13672 2 7.16616 2 12.1367C2 17.1073 6.02944 21.1367 11 21.1367C15.1031 21.1367 18.5649 18.391 19.6482 14.6367M21 10.1367V4.13672M21 10.1367H15"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardRefreshIcon;
